import { render, staticRenderFns } from "./QuestionAttempts.vue?vue&type=template&id=7a90e000"
import script from "./QuestionAttempts.vue?vue&type=script&lang=js"
export * from "./QuestionAttempts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports